import React, { ReactNode } from "react";
import ZTable from "@organisms/ZTable";
import {
	IZEditOrCloneProductTemplateUpdateTableProps,
	TemplateDataType
} from "./interface";
import { ZomentumRoutes } from "@/Contracts";
import { shortenText } from "@/Utils";
import { Link } from "react-router-dom";

const columns = [
	{
		title: "Template Name",
		dataIndex: "templateName",
		render: (_text: unknown, record: TemplateDataType): ReactNode => {
			return (
				<Link
					to={ZomentumRoutes.TemplatesDetail.replace(
						":id",
						record.templateId
					)}
				>
					{!!record?.templateName?.length
						? shortenText(record.templateName, 45)
						: "--"}
				</Link>
			);
		},
		sorter: (a: TemplateDataType, b: TemplateDataType) => {
			return (a.templateName ? a.templateName : "").localeCompare(
				b.templateName ? b.templateName : ""
			);
		}
	}
];

const ZEditOrCloneProductTemplateUpdateTable = ({
	onDataSelection,
	templatesToUpdate
}: IZEditOrCloneProductTemplateUpdateTableProps) => {
	return (
		<ZTable
			rowSelection={{
				type: "checkbox",
				onChange: (
					_selectedRowKeys: React.Key[],
					selectedRows: TemplateDataType[]
				) => {
					onDataSelection(selectedRows);
				}
			}}
			columns={columns}
			dataSource={[...templatesToUpdate].map((template, i) => ({
				templateName: template.name,
				templateId: template.id,
				key: `template-data-${i}`
			}))}
			pagination={false}
			scroll={{ y: 200, x: "100%" }}
			loading={false}
		/>
	);
};

export default ZEditOrCloneProductTemplateUpdateTable;
